import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'vue-datetime/dist/vue-datetime.css'
import Notifications from 'vue-notification'

Vue.config.productionTip = false

Vue.use(Notifications)
//Vue.component('vue-simple-spinnner', Spinner)

new Vue({
  router,
  data: store,
  template: "<App/>",
  components: {App}
}).$mount('#app')
